import Vue from "vue";
import VueRouter from "vue-router";
import Base from "../views/Base.vue";
import Home from "../views/User/Home.vue";
import AuditHome from "../views/Audit/Home.vue";
import UserAuditPeriods from "../views/User/AuditPeriods.vue";
import Bookings from "../views/User/Bookings.vue";
import Contact from "../views/Contact.vue";
import { authGuard } from "../auth/authGuard";
import AdminUser from "../views/Admin/User.vue";
import AuditAuditPeriod from "../views/Audit/AuditPeriod.vue";
import { stateGuard } from "../auth/stateGuard";
import AdminUsers from "../views/Admin/Users.vue";
import UserProfile from "../views/User/Profile.vue";
import UserFundBase from "../views/User/Fund/Base.vue";
import UserFundEdit from "../views/User/Fund/Edit.vue";
import UserFundStep from "../views/User/Fund/Step.vue";
import UserAuditPeriod from "../views/User/AuditPeriod.vue";
import AuditFundStep from "../views/Audit/Fund/Step.vue";
import { permissionGuard } from "../auth/permissionGuard";
import AdminBookings from "../views/Admin/Bookings.vue";
import AdminBookingsYears from "../views/Admin/BookingsYears.vue";
import AdminOffers from "../views/Admin/Offers.vue";
import UserFundMinimal from "../views/User/Fund/Minimal.vue";
import AuditFundMinimal from "../views/Audit/Fund/Minimal.vue";
import UserFundProtocol from "../views/User/Fund/Protocol.vue";
import AuditYears from "../views/Audit/Years.vue";
import AuditYear from "../views/Audit/Year.vue";
import AuditOptions from "../views/Audit/Options.vue";
import AuditFundProtocol from "../views/Audit/Fund/Protocol.vue";
import UserFundFinalReport from "../views/User/Fund/FinalReport.vue";
import AuditFundFinalReport from "../views/Audit/Fund/FinalReport.vue";
import UserAuditPeriodInterview from "../views/User/AuditPeriod/Interview.vue";
import UserFundProvisionalReport from "../views/User/Fund/ProvisionalReport.vue";
import AuditFundProvisionalReport from "../views/Audit/Fund/ProvisionalReport.vue";
import AuditUserFundProvisionalReport from "../views/Audit/Fund/UserProvisionalReport.vue";
import AuditFundBase from "../views/Audit/Fund/Base.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "",
    component: Base,
    props: true,
    beforeEnter: authGuard,
    children: [
      {
        path: "/",
        name: "home",
        component: Home,
        beforeEnter: stateGuard(["APPROVED", "STAFF"]),
      },
      {
        path: "/auditperiods",
        name: "userAuditPeriods",
        component: UserAuditPeriods,
        beforeEnter: stateGuard(["APPROVED", "STAFF"]),
      },
      {
        path: "/auditperiods/:id",
        name: "userAuditPeriod",
        component: UserAuditPeriod,
        beforeEnter: stateGuard(["APPROVED", "STAFF"]),
        props: true,
      },
      {
        path: "/bookings",
        name: "bookings",
        component: Bookings,
        beforeEnter: stateGuard(["APPROVED", "STAFF"]),
      },
      {
        path: "/profile",
        name: "userProfile",
        component: UserProfile,
        props: true,
      },
      {
        path: "/contact",
        name: "contact",
        component: Contact,
      },
      {
        path: "/auditperiod/:id/interview",
        name: "userAuditPeriodInterview",
        component: UserAuditPeriodInterview,
        props: true,
        beforeEnter: stateGuard(["APPROVED", "STAFF"]),
      },
      {
        path: "/funds/:id/base",
        name: "userFundBase",
        component: UserFundBase,
        props: true,
        beforeEnter: stateGuard(["APPROVED", "STAFF"]),
      },
      {
        path: "/funds/:id/edit",
        name: "userFundEdit",
        component: UserFundEdit,
        props: true,
        beforeEnter: stateGuard(["APPROVED", "STAFF"]),
      },
      {
        path: "/funds/:id/minimal",
        name: "userFundMinimal",
        component: UserFundMinimal,
        props: true,
        beforeEnter: stateGuard(["APPROVED", "STAFF"]),
      },
      {
        path: "/funds/:id/step",
        name: "userFundStep",
        component: UserFundStep,
        props: true,
        beforeEnter: stateGuard(["APPROVED", "STAFF"]),
      },
      {
        path: "/funds/:id/provisionalreport",
        name: "userProvisionalReport",
        component: UserFundProvisionalReport,
        props: true,
        beforeEnter: stateGuard(["APPROVED", "STAFF"]),
      },
      {
        path: "/funds/:id/finalreport",
        name: "userFinalReport",
        component: UserFundFinalReport,
        props: true,
        beforeEnter: stateGuard(["APPROVED", "STAFF"]),
      },
      {
        path: "/funds/:id/protocol",
        name: "userFundProtocol",
        component: UserFundProtocol,
        props: true,
        beforeEnter: stateGuard(["APPROVED", "STAFF"]),
      },
      {
        path: "/admin/users",
        name: "adminUsers",
        component: AdminUsers,
        beforeEnter: permissionGuard(["admin:users"]),
      },
      {
        path: "/admin/users/:id",
        name: "adminUser",
        component: AdminUser,
        beforeEnter: permissionGuard(["admin:users"]),
        props: true,
      },
      {
        path: "/admin/offers",
        name: "adminOffers",
        component: AdminOffers,
        beforeEnter: permissionGuard(["admin:users"]),
      },
      {
        path: "/admin/bookings",
        name: "adminBookingsYears",
        component: AdminBookingsYears,
        beforeEnter: permissionGuard(["admin:users"]),
      },
      {
        path: "/admin/bookings/:year",
        name: "adminBookings",
        component: AdminBookings,
        beforeEnter: permissionGuard(["admin:users"]),
        props: true,
      },
      {
        path: "/audit",
        name: "auditHome",
        component: AuditHome,
        beforeEnter: permissionGuard(["audit:users"]),
      },
      {
        path: "/audit/years",
        name: "auditYears",
        component: AuditYears,
        beforeEnter: permissionGuard(["audit:users"]),
      },
      {
        path: "/audit/years/:year",
        name: "auditYear",
        component: AuditYear,
        beforeEnter: permissionGuard(["audit:users"]),
        props: true,
      },
      {
        path: "/audit/options",
        name: "auditOptions",
        component: AuditOptions,
        beforeEnter: permissionGuard(["audit:finish"]),
      },
      {
        path: "/audit/auditperiods/:id",
        name: "auditAuditPeriod",
        component: AuditAuditPeriod,
        beforeEnter: permissionGuard(["audit:users", "admin:users"]),
        props: true,
      },
      {
        path: "/audit/funds/:id/minimal",
        name: "auditFundMinimal",
        component: AuditFundMinimal,
        beforeEnter: permissionGuard(["audit:users"]),
        props: true,
      },
      {
        path: "/audit/funds/:id/step",
        name: "auditFundStep",
        component: AuditFundStep,
        beforeEnter: permissionGuard(["audit:users"]),
        props: true,
      },
      {
        path: "/audit/funds/:id/provisionalreport",
        name: "auditFundProvisionalReport",
        component: AuditFundProvisionalReport,
        beforeEnter: permissionGuard(["audit:users"]),
        props: true,
      },
      {
        path: "/audit/funds/:id/userprovisionalreport",
        name: "auditUserFundProvisionalReport",
        component: AuditUserFundProvisionalReport,
        beforeEnter: permissionGuard(["audit:users"]),
        props: true,
      },
      {
        path: "/audit/funds/:id/finalreport",
        name: "auditFundFinalReport",
        component: AuditFundFinalReport,
        beforeEnter: permissionGuard(["audit:users"]),
        props: true,
      },
      {
        path: "/audit/funds/:id/protocol",
        name: "auditFundProtocol",
        component: AuditFundProtocol,
        props: true,
        beforeEnter: permissionGuard(["audit:users"]),
      },
      {
        path: "/audit/funds/:id/base",
        name: "auditFundBase",
        component: AuditFundBase,
        beforeEnter: permissionGuard(["audit:finish"]),
        props: true,
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
